<template>
	<div :class="$style.layout">
		<div :class="[$style['header'], $style['flex']]" style="padding-top:0">
			<div>
				<el-page-header :content="`查看紀錄`" @back="goBack"></el-page-header>
			</div>
		</div>
		<div :class="[$style.center]">
			<div :class="[$style['center__search']]">
				<h4>相關資訊</h4>
			</div>
			<div :class="[$style['center__relativeDetail']]">
				<div v-for="(eachColumn, eachIndex) in upperColumn" :key="eachIndex"
					:class="[$style['center__detailText']]">
					<template v-if="eachColumn.key !== 'operatorType'">
						<span>{{ eachColumn.showKey }}</span>
						<span>{{ eachColumn.value }}</span>
					</template>
					<template v-if="eachColumn.key === 'operatorType'">
						<span>{{ eachColumn.showKey }}</span>
						<span>{{ eachColumn.value[0] }}-<span :style="`color: ${eachColumn.value[2]}`">{{ eachColumn.value[1] }}</span></span>
					</template>
				</div>
			</div>
		</div>

		<div :class="[$style.center]">
			<div :class="[$style['center__search']]">
				<h4>{{ addOrSubText }}商品</h4>
			</div>
		</div>
		<div class="el-table-wrapper" :class="$style.paddingSet">
			<el-table v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中" :data="tableData"
				:default-sort="{ prop: 'created', order: 'descending' }" style="padding:0 20px 40px">
				<el-table-column v-slot="{ row }" label="圖片">
					<img v-if="row.image" width="100%" :src="row.image" />
					<img v-else :src="require(`@assets/images/icons/face-cream.svg`)" style="padding-left: 20px"/>
				</el-table-column>
				<el-table-column v-slot="{ row }" label="商品">
					<div :class="$style.displayColumn">
						<span>{{ row.title }}</span>
						<span>{{ row.category_title }}</span>
					</div>
				</el-table-column>
				<el-table-column v-slot="{ row }" label="分店及規格">
					<div :class="$style.displayColumn">
						<span>{{ row.product_title }}</span>
						<span v-for="(spec, index) in row.spec" :key="index">{{ spec.title }}: {{ spec.values[0].title }}
						</span>
					</div>
				</el-table-column>
				<el-table-column v-slot="{ row }" label="商品貨號">
					<span>{{ row.no }}</span>
				</el-table-column>
				<el-table-column v-slot="{ row }" label="進貨數量">
					<span>{{ row.value }}</span>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InventoryHistoryDetail',
	components: {},
	mixins: [],
	props: {
		historyDetail: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			tableData: [], // 此table資料
			tryingToGetOrder: false, // 獲取資料中，lock Table
			upperColumn: [
				{
					key: 'no',
					showKey: '單號',
					value: ''
				},
				{
					key: 'createdAt',
					showKey: '建立日期',
					value: ''
				},
				{
					key: 'operatorType',
					showKey: '種類',
					value: ''
				},
				{
					key: 'createdBy',
					showKey: '操作人員',
					value: ''
				},
				{
					key: 'productTitle',
					showKey: '進貨點',
					value: ''
				},
				{
					key: 'note',
					showKey: '備註',
					value: ''
				}
			]
		};
	},
	provide() { },
	inject: [],
	computed: {
		addOrSubText() {
			return this.historyDetail.operatorType === 'sub' ? '退貨' : '進貨'
		},
	},
	watch: {},
	created() { },
	mounted() {
		this.tableData = this.historyDetail.details
		this.upperColumn.forEach(item => {
			this.$set(item, 'value', this.historyDetail[item.key])
			if (item.key === 'productTitle') {
				this.$set(item, 'showKey', this.historyDetail.operatorType === 'sub' ? '退貨點' : '進貨點')
			}
			if (item.key === 'operatorType') {
				const typeObj = {
					'add': ['進貨單', '新增', '#12C494'],
					'sub': ['退貨單', '減少', 'red'],
					'allocate': ['進貨單', '調配', '#12C494'],
				}
				this.$set(item, 'value', typeObj[this.historyDetail.operatorType])
			}
		})
	},
	methods: {
		/**
		 * @description 返回
		 */
		goBack() {
			this.$emit('toTabShow')
		}
	},
};
</script>

<style lang="scss" module>

.layout {
	padding: 20px;
	margin-top: 10px;

	:global {
		.el-table__row {
			td {
				background-color: $color-line;
			}
		}
	}
}

.paddingSet {
	:global {
		.el-table_1_column_1>.cell {
			padding-left: 10px;
		}
	}
}

.center {
	padding: 18px 20px;
	display: flex;
	flex-direction: column;
	background-color: white;

	&:global {
		&.isEmployeeMob {
			padding: 18px 0;

			@include max-sm {
				padding: 18px 0;
			}
		}
	}

	&__detailText {
		display: flex;
		flex-direction: column;

		span {
			&:first-child {
				margin-bottom: 10px;
			}

			&:nth-child(2) {
				color: $color-secondary;
			}
		}
	}

	&__relativeDetail {
		background-color: $color-line;
		width: 100%;
		height: 156px;
		padding: 20px;
		display: flex;
		flex-wrap: wrap;

		>div {
			flex-basis: 25%;
			box-sizing: border-box;
			width: 25%;
		}
	}

	&__search {
		display: flex;
		justify-content: space-between;

		:global {
			.el-icon-date::before {
				padding-right: 10px
			}
		}

		&:global {
			&.isEmployeeMob {
				flex-direction: column;

				@include max-sm {
					padding: 18px 0;
				}
			}
		}
	}
}

.flex {
	display: flex;
	justify-content: space-between;
	align-items: center;

	@include pad {
		flex-wrap: wrap;
	}
}

.header {
	background-color: $color-body-bg;
	padding: 20px 0;

	:global {
		.el-page-header {
			align-items: center;
			font-size: 22px;
		}

		.el-page-header__left {
			border: 1px solid $color-border-for-bg-white;
			border-radius: $border-radius;
			padding: 12px 24px;
			background-color: white;
		}
	}
}

.displayColumn {
	display: flex;
	flex-direction: column;

}
</style>
